import React, { useContext } from "react";
import { firestore } from '../firebase.js';
import { UserContext } from "../Providers/UserProvider";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import DashBoardInfo from '../Components/DashBoardInfo';
import AssignJob from '../Components/AssignJob';
import ViewMyJobs from '../Components/ViewMyJobs';

function UserDashboard(){
  const [openFilter, setOpenFilter] = React.useState(false);

  const user = useContext(UserContext);

  return(
    <>
      <Navbar />
      { (user)
        ?
          <>
            <DashBoardInfo
              user={user}
            />
            <AssignJob
              user={user}
              setOpenFilter={setOpenFilter}
              openFilter={openFilter}
            />
            <ViewMyJobs
              user={user}
            />
          </>
        :
          <>
          </>
      }
      <Footer />
    </>
  );
}

export default UserDashboard;